$.widget('photoderm.buynow', {
	options: {
		classes: {
			hide: '_hide',
		},
	},

	_create() {
		this._bind();
	},

	_bind() {
		this._cache();
		this.visibilityToggle();
	},

	_cache() {
		this.$element = $(this.element);
		this.$footer = $('[data-role=footer]');
	},

	visibilityToggle() {
		const { classes } = this.options;

		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				this.$element.toggleClass(classes.hide, entry.isIntersecting);
			});
		});

		observer.observe(this.$footer[0]);
	}
});